import { Button, ButtonTheme } from '@cian/button-component';
import * as React from 'react';

import { TCallbackOpener } from '../../types/callbackPopup';
import { useCallbackButton } from './useCallbackButton';

interface ILegacyCallBackButtonContainerProps {
  placeType: TCallbackOpener;
}

export function LegacyCallBackButtonContainer({ placeType }: ILegacyCallBackButtonContainerProps) {
  const [isCallbackAvailable, handleCallbackButtonClick] = useCallbackButton(placeType);

  if (!isCallbackAvailable) {
    return null;
  }

  return (
    <Button theme={ButtonTheme.Ghost} onClick={handleCallbackButtonClick}>
      Перезвоните мне
    </Button>
  );
}
